module.exports = __webpack_public_path__ + "static/media/car-bus.a14fd6ba.svg";